import { useRecoilState } from "recoil";
import axios from "axios";
import { getImagesDB } from "@api";
import { universalFilterPromptState } from "@atoms";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useUniversalFilterHandler = () => {
  const [universalFilterPrompt, setUniversalFilterPrompt] = useRecoilState(universalFilterPromptState);

  const handleUniversalFilterApplyToAll = async () => {
    try {
      const localstr = localStorage.getItem("uniqueUserId");
      const userEmail = localStorage.getItem("userEmail") || "";
      const sessionId = localStorage.getItem("sessionId");
      const { changeType, filterType, changedImageId } = universalFilterPrompt;
      
      // Make API call to apply/remove filter to all images
      if (changeType === 'ADD') {
        if (filterType === 'bw') {
          await axios.post(`${BASE_URL}/add-bw-filter/${localstr}`, { email: userEmail, sessionId });
        } else if (filterType === 'bluewhite') {
          await axios.post(`${BASE_URL}/add-bluewhite-filter/${localstr}`, { email: userEmail, sessionId });
        }
      } else if (changeType === 'REMOVE') {
        if (filterType === 'bw') {
          await axios.post(`${BASE_URL}/remove-bw-filter/${localstr}`, { email: userEmail, sessionId });
        } else if (filterType === 'bluewhite') {
          await axios.post(`${BASE_URL}/remove-bluewhite-filter/${localstr}`, { email: userEmail, sessionId });
        }
      }
      
      // Refresh images from database to get updated filter states
      await getImagesDB();

      // Close the prompt
      setUniversalFilterPrompt({ show: false, changeType: null, filterType: null, changedImageId: null });
      
    } catch (error) {
      console.error('Universal filter update error:', error);
      // Keep prompt open on error so user can retry
    }
  };
  
  const handleUniversalFilterApplyToCurrentOnly = () => {
    // Just close the prompt - the changed image already has the filter applied
    setUniversalFilterPrompt({ show: false, changeType: null, filterType: null, changedImageId: null });
  };

  return {
    handleUniversalFilterApplyToAll,
    handleUniversalFilterApplyToCurrentOnly
  };
};